import React from 'react';

import { CardNumberElement } from '@stripe/react-stripe-js';
import type { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';

import { stripeElementDomId } from '#src/app/shared/utils/payments';

import { useHideAriaHiddenStripeInputsFromTabOrder } from '../../hooks';

type Props = {
	onChange?: (event: StripeCardNumberElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardNumberElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	const containerRef = useHideAriaHiddenStripeInputsFromTabOrder();

	return (
		<div ref={containerRef}>
			<CardNumberElement
				id={stripeElementDomId('cardNumber')}
				options={{ style: { base: { fontSize: '16px' } } }}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</div>
	);
};
